import React from 'react';
import Grid from '../components/Core/Grid';
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

export default function UsinaVinculosGridViewer(props: any) {
    const usinaId = props.data?.id;

    const initialFilter = usinaId
        ? [{ name: 'usina_id', operator: 'eq', value: String(usinaId) }]
        : [];

    return (
        <>
            <WindowBody noPadding>
                <Grid
                    router="usinacontrato"
                    initialFilter={initialFilter}
                />
            </WindowBody>
            <WindowFooter>
                <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
            </WindowFooter>
        </>
    );
}
